import React from 'react';
import styled from '@emotion/styled';
import { Only } from 'ui/components/elements/Only/Only';
import { mqMin } from 'utils/responsive';

const Container = styled.section`
    background-color: var(--dark-blue);
    padding: 67px 0 40px 0;

    ${mqMin('NARROW')} {
        padding: 79px 0 43px 0;
    }
`;

const H2 = styled.h2`
    text-align: center;
    color: #fff;
    font-size: min(6.3vw, 24px);
    line-height: 1.5em;
    letter-spacing: 0.05em;
    margin-bottom: 48px;

    strong {
        font-size: min(6.6vw, 28px);
    }

    ${mqMin('NARROW')} {
        font-size: 1.125rem; /*18px*/
        margin-bottom: 43px;

        strong {
            font-size: 1.75rem; /*28px*/
        }
    }
`;

const PlanContainer = styled.div`
    text-align: center;
    color: #fff;
    line-height: 1.8em;
    letter-spacing: 0.1em;
    margin: 0 auto 65px auto;

    ${mqMin('NARROW')} {
        margin: 0 auto 61px auto;
    }
`;

const PlanList = styled.div`
    ${mqMin('NARROW')} {
        display: flex;
        justify-content: center;
    }
`;

const PlanListItem = styled.div`
    width: 320px;
    margin: 0 auto 39px auto;
    opacity: 0;
    transition: opacity 1s cubic-bezier(0.25, 1, 0.5, 1);
    opacity: 0;
    transform: translateY(30px);
    transition:
        transform 1s cubic-bezier(0.25, 1, 0.5, 1),
        opacity 1s cubic-bezier(0.25, 1, 0.5, 1);

    h3 {
        background-color: var(--color-lightblue);
        border-radius: 12px 12px 0 0;
        text-align: center;
        font-size: 1.125rem; /*18px*/
        letter-spacing: 0.1em;
        line-height: 1.8em;
        padding: 12px 0;
    }

    ${mqMin('NARROW')} {
        margin: 0 11px 14px 11px;
    }
`;

const Price = styled.div`
    background-color: #fff;
    border-radius: 0 0 12px 12px;
    text-align: center;
    font-size: 1.125rem; /*18px*/
    letter-spacing: 0.1em;
    line-height: 1.8em;
    padding: 24px 0;

    strong {
        font-size: 38px;
    }
`;

const Attention = styled.div`
    text-align: left;
    color: #fff;
    font-size: 0.8em;
    letter-spacing: 0.1em;
    margin-top: 14px;
    font-weight: normal;
`;

export const Plan: React.FC = () => {
    return (
        <Container>
            <H2 className="fadein fadein_y">MAnyの料金プラン</H2>
            <PlanContainer className="fadein fadein_y">
                企業検索やオファー送信など、
                <Only sp>
                    <br />
                </Only>
                マッチング成立までは
                <Only sp>
                    <br />
                </Only>
                基本無料でご利用いただけます。
            </PlanContainer>
            <PlanList className="fadeinLi">
                <PlanListItem>
                    <h3>マッチング成立/1件</h3>
                    <Price>
                        <strong>50,000</strong>円(税抜)
                    </Price>
                </PlanListItem>
                <PlanListItem>
                    <h3>プレミアムオファー/1件</h3>
                    <Price>
                        <strong>20,000</strong>円(税抜)
                    </Price>
                    <Attention>
                        ※プレミアムオファーをご利用いただくと、M&A検討企業がMAnyにログインした際にポップアップ通知が表示されます。
                        <br />
                        マッチング後も、M&A検討企業の受信BOX内で2週間上位に表示され、他のDMより発見性・開封率が高くなります。
                    </Attention>
                </PlanListItem>
            </PlanList>
        </Container>
    );
};
